import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs/Observable';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule, AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import { User } from '../.modal/user';
import { Enterprise } from '../.modal/enterprise';
import { Project } from '../.modal/project';

@Injectable()
export class MainService {
	user: Observable<firebase.User>;
	items: FirebaseListObservable<any[]>;
	userBelongsToEnterprises: string[];
	testProjects: Observable<string>;
	public projects = [];
	public enterprises = [];
	constructor(private firebaseAuth: AngularFireAuth, public af: AngularFireAuth, public db: AngularFireDatabase) {
		this.user = JSON.parse(localStorage.getItem('user'));
	}
	getUser() {
		return JSON.parse(localStorage.getItem('user'));
	}
	updateUser(userGoogle) {
		var userData = new User();
		userData.fromGoogle(this.user);
		//console.log(userData);
		this.db
			.object('users/' + this.getUserDetails().uid)
			.update(userData)
			.then(data => {
				//console.log(data);
			})
			.catch(error => {
				//console.log(error);
			});
	}
	createProject(project, enterpriseId) {
		var projects = this.db.list('enterprises/' + enterpriseId + '/projects');
		projects.push(project);
	}
	getEnterprises(callBack1, callBack2) {
		callBack1();
		this.enterprises = [];
		this.db.list('users/' + this.getUserDetails().uid).subscribe(data => {
			data.forEach((item, index) => {
				if (item.$key == 'enterprises') {
					this.userBelongsToEnterprises = item;
					this.getAllProjects();
					this.userBelongsToEnterprises.forEach((item, index) => {
						this.db.list('enterprises/' + item).subscribe(enterpriseData => {
							this.enterprises = [];
							var eachEnterprise = new Enterprise([], '');
							eachEnterprise.id = item;
							enterpriseData.forEach((item, index) => {
								if (item.$key == 'name') {
									eachEnterprise.name = item.$value;
								} else if (item.$key == 'shortName') {
									eachEnterprise.shortName = item.$value;
								}
							});
							this.enterprises.push(eachEnterprise);
						});
						return this.enterprises;
					});
				}
			});
			callBack2();
		});
		return this.enterprises;
	}
	getAllProjects() {
		return this.getProjects(function() {}, function() {});
	}
	updateProject(enterpriseId, projectKey, project) { 
		this.db
			.object('enterprises/' + enterpriseId + '/projects/' + projectKey)
			.update(project)
			.then(data => {
				console.log(data);
			})
			.catch(error => {
				console.log(error);
			});
	}
	getProjects(callBack1, callBack2) {
		callBack1();
		this.userBelongsToEnterprises.forEach((enterprise, index) => {
			this.db.list('enterprises/' + enterprise + '/projects').subscribe(data => {
				console.log(data);
				callBack1();
				this.projects = [];
				data.forEach((item, index) => {
					item.enterpriseId = enterprise;
					this.projects.push(item);
				});
				console.log(this.projects);
				callBack2();
				return this.projects;
			});
		});
		return this.projects;
	}
	createUser(user, enterpriseId) {
		var userData = new User();
		userData.login = user.email;
		userData.enterprises = [enterpriseId];
		this.db
			.object('users/' + this.getUserDetails().uid)
			.update(userData)
			.then(data => {
				//console.log(data);
			})
			.catch(error => {
				//console.log(error);
			});
	}
	createEnterprise(users, type) {
		//create enterprise data
		var enterprise = new Enterprise(users, type);

		this.db
			.object('enterprises/' + enterprise.id)
			.update(enterprise)
			.then(data => {
				//console.log(data);
				//console.log('Enterprise id-' + enterprise.id);
				this.createUser(this.getUser(), enterprise.id);
			})
			.catch(error => {
				console.log(error);
			});
	}
	registerUser() {
		var updateUserOnLogin = true;
		this.db.list('users/' + this.getUserDetails().uid).subscribe(data => {
			data.forEach((item, index) => {
				if (item.$key == 'enterprises') {
					this.userBelongsToEnterprises = item;
					//console.log(this.userBelongsToEnterprises + ';' + this.userBelongsToEnterprises.length);
					//console.log(this.userBelongsToEnterprises[0]);
					this.getProjects(function() {}, function() {});
				}
			});
			//console.log(data);
			if (data == null || data.length == 0) {
				var userData = new User();
				userData.login = this.getUserDetails().email;
				this.createEnterprise([this.getUserDetails().uid], 'private');
			} else if (!updateUserOnLogin) {
				updateUserOnLogin = true;
				this.updateUser(data);
			}
		});
	}

	getUserDetails() {
		return JSON.parse(localStorage.getItem('user'));
	}
}



// WEBPACK FOOTER //
// D:/OneDrive/Dev/firebase/alagatime_bootstrap/src/app/.providers/main.service.ts